import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import { useTenantId } from './useTenant';

/**
 * GET /api/tenants/<id>/promise-keeping — ar pristatėm tada, kada sakėm.
 *
 * useClientReliability() veidrodis: tas matuoja, kiek galima pasitikėti
 * kliento objekto duomenimis, šis — kiek klientas gali pasitikėti mumis.
 * Ta pati atsakymo forma ir tos pačios sąžiningumo taisyklės, sąmoningai:
 * žr. blueprints/reporting.py promise_keeping() ir core/promise_keeping.py.
 *
 * Grąžina { rows, window_days, low_sample_threshold }. Kiekviena eilutė
 * neša `on_time_rate` (0.0–1.0), `promised_count`, `worst_days_late` ir
 * `low_sample`. Vardiklis yra PAŽADAI, ne reisai — krovinys be pažadėtos
 * dienos į jį nepatenka, ir eilutės skaičius nėra „kiek jam vežėm".
 */
export function usePromiseKeeping() {
  const tenantId = useTenantId();
  return useQuery({
    queryKey: ['promise-keeping', tenantId],
    queryFn: () => api(`/api/tenants/${tenantId}/promise-keeping`),
    enabled: Boolean(tenantId),
    staleTime: 60_000,
  });
}
